import Quickshop from './Quickshop';

export default class ProductListItem {
  constructor(component) {
    this.$el = $(component.el);
    $('.product-list-item-thumbnail', this.$el).on('click', event => this.redirectToProduct(event));
    this.productHover = $('[data-product-hover]').data('product-hover');

    if (this.productHover === 'quick-shop') {
      this.quickshop = new Quickshop();
      $('.quick-shop-modal-trigger', this.$el).on('click', event => this.openQuickShop(event));
      $('.quick-shop-modal-trigger', this.$el).on('mouseover', event => this.preloadQuickshop(event));
    }
  }

  remove() {
    if (this.quickshop) {
      this.quickshop.unload();
      $('.quick-shop-modal-trigger', this.$el).off('click');
      $('.quick-shop-modal-trigger', this.$el).off('mouseover');
    }
    $('.product-list-item-thumbnail', this.$el).off('click');
  }

  redirectToProduct(e) {
    const $target = $(e.target);

    const url = !$target.hasClass('quick-shop-modal-trigger') ? $target.data('url') : null;
    const isSlider = $target.closest('.flickity-slider').length;

    if (isSlider) { return; }

    if (url) {
      return window.location = url;
    }
  }

  openQuickShop(e) {
    const productUrl = e.currentTarget.getAttribute('data-product-url');
    const productSha256 = e.currentTarget.getAttribute('data-product-sha256');
    return this.quickshop.open(productUrl, productSha256);
  }

  preloadQuickshop(e) {
    const productUrl = e.currentTarget.getAttribute('data-product-url');
    const productSha256 = e.currentTarget.getAttribute('data-product-sha256');
    return this.quickshop.load(productUrl, productSha256);
  }
}
